export default "__VITE_ASSET__CMaWBqZr__"